const PolyfillAddIcon = (props: any) => {
  return (
    <svg
      {...props}
      width="15"
      height="18"
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7684 4.32792L8.41927 1.24509C7.85223 0.918304 7.14779 0.918304 6.58082 1.24509L1.23169 4.32792C0.664721 4.65467 0.3125 5.26364 0.3125 5.91718V12.0828C0.3125 12.7364 0.664721 13.3453 1.23172 13.6721L6.58082 16.7549C7.14785 17.0817 7.85217 17.0817 8.41927 16.7549L13.7684 13.6721C14.3354 13.3453 14.6876 12.7363 14.6876 12.0828V5.91715C14.6876 5.26361 14.3354 4.65464 13.7684 4.32792ZM13.4352 12.0828C13.4352 12.2911 13.323 12.4853 13.1422 12.5894L7.79304 15.6723C7.61236 15.7765 7.38776 15.7765 7.20701 15.6723L1.85788 12.5894C1.67713 12.4853 1.56485 12.2912 1.56485 12.0828V5.91715C1.56485 5.7088 1.67713 5.51464 1.85788 5.41049L7.20704 2.32766C7.38767 2.2235 7.61232 2.22347 7.79308 2.32766L13.1422 5.41049C13.323 5.51467 13.4352 5.7088 13.4352 5.91715V12.0828Z"
        fill="white"
        stroke="white"
        strokeWidth="0.4"
      />
      <path
        d="M10.0048 8.37526H8.12626V6.50006C8.12626 6.15484 7.84591 5.875 7.50007 5.875C7.15422 5.875 6.87387 6.15484 6.87387 6.50006V8.37526H4.99533C4.64949 8.37526 4.36914 8.6551 4.36914 9.00032C4.36914 9.34554 4.64949 9.62539 4.99533 9.62539H6.87381V11.5006C6.87381 11.8458 7.15416 12.1256 7.5 12.1256C7.84585 12.1256 8.12619 11.8458 8.12619 11.5006V9.62539H10.0047C10.3506 9.62539 10.6309 9.34554 10.6309 9.00032C10.6309 8.6551 10.3506 8.37526 10.0048 8.37526Z"
        fill="white"
        stroke="white"
        strokeWidth="0.4"
      />
    </svg>
  );
};

export default PolyfillAddIcon;
